import React, { useEffect } from "react";
import Cardiologycon from "./Cardiologycon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Cardiology() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Cardiologycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Cardiologist in Vijayanagar</title>
        <meta
          name="description"
          content="We have the best cardiologist in Vijayanagar and Whitefield. If you are looking for this then feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Cardiologist in Whitefield, Best Cardiologist in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestcardiologyservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestcardiologyservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert cardiology services including heart health evaluations, diagnosis and treatment of cardiac conditions, ECG and echocardiography, blood pressure management, cholesterol screening, and personalized cardiac care.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Cardiac health evaluations",
              "ECG and echocardiography screening",
              "Hypertension and blood pressure care",
              "Cholesterol and lipid management",
              "Coronary artery disease diagnosis",
              "Arrhythmia assessment",
              "Heart disease preventive care",
            ],
            keywords: [
              "best cardiology services in Immadihalli",
              "best cardiology services in Whitefield",
              "best cardiology services in Bangalore",
              "best cardiology services in Kundalahalli",
              "best cardiology services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Cardiologist in Vijayanagar service sets us apart as a leader in
        Cardiology services. Contact us for the best cardiologist in
        Vijayanagar.
      </h2>
      <Servicebanner name="Cardiology" banner={"../photo/dd3.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Cardiology;
